import { Space, Table, Tag, Tooltip } from 'antd'
import moment from 'moment'
import { useImperativeHandle, useState } from 'react'
import { forwardRef } from 'react'
import { Link, Router, Route, useNavigate } from 'react-router-dom'
import IsSticky from '../isSticky/isSticky'
import './postTable.css'

const PostTable = forwardRef((props, ref) => {
  const columns = [
    {
      title: '帖子编号',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: '帖子标题',
      dataIndex: 'title',
      key: 'title',
      width: '20%',
      ellipsis: {
        showTitle: false,
      },
      render: (title) => (
        <Tooltip placement="topLeft" title={title}>
          {title}
        </Tooltip>
      ),
    },
    {
      title: '帖子状态',
      dataIndex: 'auditStatus',
      key: 'auditStatus',
    },
    {
      title: '帖子类型',
      key: 'typeName',
      dataIndex: 'typeName',
    },
    {
      title: '是否置顶',
      key: 'is_sticky',
      dataIndex: 'isSticky',
    },
    {
      title: '昵称',
      key: 'appellation',
      dataIndex: 'appellation',
    },
    {
      title: '手机号码',
      key: 'phone',
      dataIndex: 'phone',
    },
    {
      title: '发布时间',
      key: 'createdAt',
      dataIndex: 'createdAt',
      width: '18%',
      ellipsis: {
        showTitle: false,
      },
      render: (created_at) => (
        <Tooltip placement="topLeft" title={created_at}>
          {created_at}
        </Tooltip>
      ),
    },

    {
      title: '操作',
      key: 'action',
      fixed: 'right',
      // width:'20%',
      render: (_, record) => (
        <Space size="middle">
          <a
            onClick={() => {
              jumpToDetailPost(record)
            }}
          >
            查看
          </a>
          <IsSticky info={record} setIsFresh={props.setIsFresh} />
        </Space>
      ),
    },
  ]

  const [data, setData] = useState([])
  const navigate = useNavigate()

  const jumpToDetailPost = (info) => {
    console.log(info)
    navigate('/postDetail', { state: { info: info } })
  }
  //将是否置顶转化为文字
  const switchIsSticky = (num) => {
    switch (num) {
      case 0:
        return '未置顶'
      case 1:
        return '已置顶'
      default:
        break
    }
  }

  const switchAuditStatus = (num) => {
    switch (num) {
      case 1:
        return '待审核'

      case 2:
        return '审核通过'

      case 3:
        return '审核不通过'

      default:
        break
    }
  }

  const switchtype = (num) => {
    switch (num) {
      case 1:
        return '合租'

      case 2:
        return '转租'

      case 3:
        return '出售'

      case 4:
        return '求购'

      default:
        break
    }
  }

  const changeTable = (data) => {
    data.map((info, index) => {
      info.isSticky = switchIsSticky(info.is_sticky)
      info.auditStatus = switchAuditStatus(info.audit_status)
      info.createdAt = moment(info.created_at).format('YYYY-MM-DD HH:mm:ss')
      info.typeName = switchtype(info.type)
      info.key = index
      return info
    })
    // console.log(data);
    setData(data)
  }

  useImperativeHandle(ref, () => ({
    changeTable,
  }))
  return (
    <div className="postTable" style={{ marginBottom: '20px' }}>
      <Table
        scroll={{
          x: 1500,
          y: 320,
        }}
        columns={columns}
        dataSource={data}
        pagination={false}
      />
    </div>
  )
})

export default PostTable
